// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Overall — pivot table styles */

.overall-page {
  display: grid;
  grid-template-rows: 36px auto auto 1fr;
  height: 100vh;
  overflow: hidden;
}
.overall-body {
  overflow: auto;
  background: var(--bg);
  padding-bottom: 80px;
}

/* KPI band */
.kpi-band {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  border-bottom: 1px solid var(--rule);
  background: var(--bg);
}
.kpi {
  padding: 16px 18px 14px;
  border-right: 1px solid var(--rule-soft);
  display: flex; flex-direction: column; gap: 4px;
}
.kpi:last-child { border-right: 0; }
.kpi .lbl {
  font-size: 10px; text-transform: uppercase; letter-spacing: .08em; color: var(--ink-4);
  font-weight: 600;
}
.kpi .val {
  font-family: var(--mono); font-size: 22px;
  font-feature-settings: 'tnum', 'zero';
  color: var(--ink); letter-spacing: -.01em;
  font-weight: 500;
}
.kpi .sub {
  font-family: var(--mono); font-size: 10.5px; font-feature-settings: 'tnum';
  color: var(--ink-3);
}
.kpi.diff .val { color: var(--diff); }
.kpi.match .val { color: var(--match); }
.kpi .spark {
  margin-top: 4px;
  height: 22px;
  display: flex;
  gap: 3px;
  align-items: flex-end;
}
.kpi .spark .b {
  width: 8px;
  background: var(--ink-4);
  opacity: .55;
}
.kpi .spark .b.cur { background: var(--accent); opacity: 1; }

/* Filter strip */
.overall-filters {
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--rule);
  background: var(--bg-elev);
  font-size: 11.5px;
  height: 32px;
}
.overall-filters .group {
  display: flex; align-items: center; gap: 0;
  padding: 0 8px;
  border-right: 1px solid var(--rule-soft);
  height: 100%;
}
.overall-filters .group .glbl {
  font-size: 10px; text-transform: uppercase; letter-spacing: .06em;
  color: var(--ink-4); margin-right: 6px;
}
.overall-filters .pill {
  padding: 0 10px;
  height: 22px;
  display: inline-flex; align-items: center; gap: 5px;
  font-size: 11px;
  color: var(--ink-3);
  border-radius: 3px;
  cursor: pointer;
  font-family: var(--mono);
  font-feature-settings: 'tnum';
}
.overall-filters .pill:hover { background: var(--bg-sunk); color: var(--ink); }
.overall-filters .pill[aria-pressed="true"] {
  background: var(--bg);
  color: var(--ink);
  box-shadow: inset 0 -2px 0 var(--ink);
}
.overall-filters .right {
  margin-left: auto;
  display: flex; gap: 14px; align-items: center;
  padding: 0 14px;
  font-family: var(--mono); font-size: 10.5px; color: var(--ink-3);
  font-feature-settings: 'tnum';
}
.overall-filters .right b { color: var(--ink); font-weight: 500; }

/* Pivot table */
.pivot {
  font-family: var(--mono);
  font-feature-settings: 'tnum', 'zero';
  font-size: 12.5px;
}
.pivot .ph,
.pivot .pr {
  display: grid;
  grid-template-columns: 24px minmax(280px, 1.4fr) repeat(6, 1fr) 1.1fr;
}
.pivot .ph {
  position: sticky; top: 0;
  z-index: 5;
  background: var(--bg-elev);
  border-top: 1px solid var(--rule);
  border-bottom: 1px solid var(--rule);
  height: 56px;
}
.pivot .ph > div {
  padding: 6px 10px;
  border-right: 1px solid var(--rule-soft);
  display: flex; flex-direction: column; justify-content: center;
}
.pivot .ph > div:last-child { border-right: 0; background: var(--bg); }
.pivot .ph .co .short {
  font-family: var(--mono); font-size: 13px; font-weight: 600;
  color: var(--ink); letter-spacing: .04em;
}
.pivot .ph .co .full {
  font-family: var(--sans); font-size: 10.5px; color: var(--ink-3);
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.pivot .ph .co .meta {
  font-family: var(--mono); font-size: 9.5px; color: var(--ink-4);
  font-feature-settings: 'tnum';
  margin-top: 2px;
}
.pivot .ph .co .meta .dot {
  display: inline-block; width: 6px; height: 6px; border-radius: 50%;
  background: var(--match); margin-right: 4px;
  vertical-align: middle;
}
.pivot .ph .co .meta.has-diff .dot { background: var(--diff); }

.pivot .ph .first {
  font-family: var(--sans);
  font-size: 10.5px; text-transform: uppercase; letter-spacing: .08em;
  color: var(--ink-3);
}
.pivot .ph .totalh {
  font-family: var(--sans);
  font-size: 11px; font-weight: 600;
  color: var(--ink);
  background: var(--bg);
  text-transform: uppercase; letter-spacing: .04em;
}
.pivot .ph .totalh .meta {
  font-family: var(--mono); font-size: 9.5px;
  color: var(--ink-3); margin-top: 2px;
  text-transform: none; letter-spacing: 0; font-weight: 400;
}

.pivot .pr {
  border-bottom: 1px solid var(--rule-soft);
  align-items: stretch;
  height: 32px;
  background: var(--bg);
}
.pivot .pr:hover { background: var(--bg-sunk); }
.pivot .pr > div {
  padding: 0 10px;
  display: flex; align-items: center;
  border-right: 1px solid var(--rule-soft);
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  justify-content: flex-end;
}
.pivot .pr > div:last-child { border-right: 0; }
.pivot .pr .lvl {
  justify-content: center;
  padding: 0;
}
.pivot .pr .name {
  justify-content: flex-start;
  font-family: var(--sans); font-size: 12.5px;
  color: var(--ink-2);
}
.pivot .pr.l0 .name { color: var(--ink); font-weight: 500; }
.pivot .pr.total {
  background: var(--bg-elev);
  font-weight: 600;
  border-top: 1px solid var(--rule);
}
.pivot .pr.total .name { color: var(--ink); }
.pivot .pr.total .cell { color: var(--ink); font-size: 13px; }

/* cell */
.cell {
  font-family: var(--mono);
  font-size: 12.5px;
  color: var(--ink);
  position: relative;
  cursor: pointer;
}
.cell:hover { background: var(--bg-sunk); }
.cell.s-match { /* default */ }
.cell.s-diff {
  background: var(--diff-bg);
  color: var(--diff);
  box-shadow: inset 0 -2px 0 var(--diff);
}
.cell.s-diff:hover { background: color-mix(in oklab, var(--diff-bg) 70%, var(--bg-sunk)); }
.cell.s-over {
  background: var(--override-bg);
  color: var(--override);
  box-shadow: inset 0 -2px 0 var(--override);
}
.cell.s-over:hover { background: color-mix(in oklab, var(--override-bg) 70%, var(--bg-sunk)); }
.cell.selected {
  outline: 1.5px solid var(--accent);
  outline-offset: -1.5px;
  z-index: 1;
}
.cell .delta {
  position: absolute;
  bottom: 1px;
  right: 6px;
  font-size: 9.5px;
  color: var(--diff);
  font-feature-settings: 'tnum';
  opacity: .85;
}
.cell.s-over .delta { color: var(--override); }

.pivot .pr .total-col {
  background: var(--bg-elev);
  font-weight: 500;
  font-size: 13px;
}
.pivot .pr.total .total-col { font-weight: 600; }

/* Row level indent ind */
.lvl-ind {
  display: inline-block;
  width: 10px;
  height: 1px;
  background: var(--ink-4);
  margin-right: 8px;
  opacity: .4;
}

/* selected detail panel */
.detail-overlay {
  position: fixed; right: 16px; bottom: 36px;
  width: 360px;
  max-height: 60vh;
  background: var(--bg);
  border: 1px solid var(--rule);
  border-left: 3px solid var(--accent);
  border-radius: 4px;
  box-shadow: 0 8px 32px rgba(0,0,0,.12);
  z-index: 60;
  overflow: auto;
  font-family: var(--sans);
  font-size: 12px;
}
.detail-overlay .dh {
  display: flex; align-items: baseline;
  padding: 12px 14px 8px;
  border-bottom: 1px solid var(--rule-soft);
  gap: 10px;
}
.detail-overlay .dh .t { font-size: 11px; text-transform: uppercase; letter-spacing: .08em; color: var(--ink-3); font-weight: 600; }
.detail-overlay .dh .x {
  margin-left: auto;
  color: var(--ink-3);
  font-family: var(--mono); font-size: 14px;
  cursor: pointer;
}
.detail-overlay .dh .x:hover { color: var(--ink); }
.detail-overlay .body {
  padding: 12px 14px 16px;
}
.detail-overlay .row-title {
  font-size: 13px; font-weight: 500; color: var(--ink);
  margin-bottom: 4px;
}
.detail-overlay .co-line {
  font-family: var(--mono); font-size: 11px; color: var(--ink-3);
  font-feature-settings: 'tnum';
  margin-bottom: 12px;
}
.detail-overlay .row-val {
  font-family: var(--mono); font-size: 22px;
  font-feature-settings: 'tnum'; color: var(--ink);
  letter-spacing: -.01em;
  margin-bottom: 2px;
}
.detail-overlay .row-val.diff { color: var(--diff); }
.detail-overlay .row-val.over { color: var(--override); }
.detail-overlay .row-sub {
  font-family: var(--mono); font-size: 11px; color: var(--ink-3);
  font-feature-settings: 'tnum';
  margin-bottom: 12px;
}
.detail-overlay .h {
  font-size: 10.5px; text-transform: uppercase; letter-spacing: .08em;
  color: var(--ink-4); font-weight: 600;
  margin: 12px 0 6px;
}
.detail-overlay .pl {
  display: grid; grid-template-columns: 1fr auto;
  font-family: var(--mono); font-size: 11.5px;
  font-feature-settings: 'tnum';
  padding: 4px 0;
  border-bottom: 1px solid var(--rule-soft);
}
.detail-overlay .pl:last-child { border-bottom: 0; }
.detail-overlay .pl .l { color: var(--ink-3); }
.detail-overlay .pl .v { color: var(--ink); text-align: right; }
.detail-overlay .actions {
  display: flex; gap: 6px;
  margin-top: 14px;
}
.detail-overlay .actions a, .detail-overlay .actions button {
  flex: 1 1;
  text-align: center;
  padding: 7px 10px;
  border: 1px solid var(--rule);
  border-radius: 3px;
  font-size: 11.5px;
  color: var(--ink-2);
  background: var(--bg);
  text-decoration: none;
  font-family: var(--sans);
  cursor: pointer;
}
.detail-overlay .actions a.primary, .detail-overlay .actions button.primary {
  border-color: var(--accent); color: var(--accent);
}
.detail-overlay .actions a:hover, .detail-overlay .actions button:hover { background: var(--bg-sunk); }
`, "",{"version":3,"sources":["webpack://./src/v2/overall.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC;EACE,aAAa;EACb,sCAAsC;EACtC,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,qCAAqC;EACrC,oCAAoC;EACpC,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,wCAAwC;EACxC,aAAa,EAAE,sBAAsB,EAAE,QAAQ;AACjD;AACA,kBAAkB,eAAe,EAAE;AACnC;EACE,eAAe,EAAE,yBAAyB,EAAE,qBAAqB,EAAE,mBAAmB;EACtF,gBAAgB;AAClB;AACA;EACE,wBAAwB,EAAE,eAAe;EACzC,qCAAqC;EACrC,iBAAiB,EAAE,sBAAsB;EACzC,gBAAgB;AAClB;AACA;EACE,wBAAwB,EAAE,iBAAiB,EAAE,6BAA6B;EAC1E,mBAAmB;AACrB;AACA,iBAAiB,kBAAkB,EAAE;AACrC,kBAAkB,mBAAmB,EAAE;AACvC;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,wBAAwB;EACxB,YAAY;AACd;AACA,qBAAqB,yBAAyB,EAAE,UAAU,EAAE;;AAE5D,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,0BAA0B;EAC1B,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,MAAM;EAC1C,cAAc;EACd,wCAAwC;EACxC,YAAY;AACd;AACA;EACE,eAAe,EAAE,yBAAyB,EAAE,qBAAqB;EACjE,mBAAmB,EAAE,iBAAiB;AACxC;AACA;EACE,eAAe;EACf,YAAY;EACZ,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,wBAAwB;EACxB,6BAA6B;AAC/B;AACA,+BAA+B,0BAA0B,EAAE,iBAAiB,EAAE;AAC9E;EACE,qBAAqB;EACrB,iBAAiB;EACjB,qCAAqC;AACvC;AACA;EACE,iBAAiB;EACjB,aAAa,EAAE,SAAS,EAAE,mBAAmB;EAC7C,eAAe;EACf,wBAAwB,EAAE,iBAAiB,EAAE,mBAAmB;EAChE,6BAA6B;AAC/B;AACA,4BAA4B,iBAAiB,EAAE,gBAAgB,EAAE;;AAEjE,gBAAgB;AAChB;EACE,wBAAwB;EACxB,qCAAqC;EACrC,iBAAiB;AACnB;AACA;;EAEE,aAAa;EACb,qEAAqE;AACvE;AACA;EACE,gBAAgB,EAAE,MAAM;EACxB,UAAU;EACV,0BAA0B;EAC1B,iCAAiC;EACjC,oCAAoC;EACpC,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,wCAAwC;EACxC,aAAa,EAAE,sBAAsB,EAAE,uBAAuB;AAChE;AACA,8BAA8B,eAAe,EAAE,qBAAqB,EAAE;AACtE;EACE,wBAAwB,EAAE,eAAe,EAAE,gBAAgB;EAC3D,iBAAiB,EAAE,qBAAqB;AAC1C;AACA;EACE,wBAAwB,EAAE,iBAAiB,EAAE,mBAAmB;EAChE,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB;AAChE;AACA;EACE,wBAAwB,EAAE,gBAAgB,EAAE,mBAAmB;EAC/D,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,qBAAqB,EAAE,UAAU,EAAE,WAAW,EAAE,kBAAkB;EAClE,wBAAwB,EAAE,iBAAiB;EAC3C,sBAAsB;AACxB;AACA,qCAAqC,uBAAuB,EAAE;;AAE9D;EACE,wBAAwB;EACxB,iBAAiB,EAAE,yBAAyB,EAAE,qBAAqB;EACnE,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,eAAe,EAAE,gBAAgB;EACjC,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB,EAAE,qBAAqB;AAClD;AACA;EACE,wBAAwB,EAAE,gBAAgB;EAC1C,mBAAmB,EAAE,eAAe;EACpC,oBAAoB,EAAE,iBAAiB,EAAE,gBAAgB;AAC3D;;AAEA;EACE,yCAAyC;EACzC,oBAAoB;EACpB,YAAY;EACZ,qBAAqB;AACvB;AACA,mBAAmB,0BAA0B,EAAE;AAC/C;EACE,eAAe;EACf,aAAa,EAAE,mBAAmB;EAClC,wCAAwC;EACxC,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB;EAC9D,yBAAyB;AAC3B;AACA,8BAA8B,eAAe,EAAE;AAC/C;EACE,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,2BAA2B;EAC3B,wBAAwB,EAAE,iBAAiB;EAC3C,mBAAmB;AACrB;AACA,sBAAsB,iBAAiB,EAAE,gBAAgB,EAAE;AAC3D;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,iCAAiC;AACnC;AACA,yBAAyB,iBAAiB,EAAE;AAC5C,yBAAyB,iBAAiB,EAAE,eAAe,EAAE;;AAE7D,SAAS;AACT;EACE,wBAAwB;EACxB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;AACA,cAAc,0BAA0B,EAAE;AAC1C,gBAAgB,YAAY,EAAE;AAC9B;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,sCAAsC;AACxC;AACA,qBAAqB,mEAAmE,EAAE;AAC1F;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,0CAA0C;AAC5C;AACA,qBAAqB,uEAAuE,EAAE;AAC9F;EACE,kCAAkC;EAClC,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,YAAY;AACd;AACA,sBAAsB,sBAAsB,EAAE;;AAE9C;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;AACA,8BAA8B,gBAAgB,EAAE;;AAEhD,yBAAyB;AACzB;EACE,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,wBAAwB;EACxB,iBAAiB;EACjB,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,eAAe,EAAE,WAAW,EAAE,YAAY;EAC1C,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,6BAA6B;EAC7B,oCAAoC;EACpC,kBAAkB;EAClB,sCAAsC;EACtC,WAAW;EACX,cAAc;EACd,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,aAAa,EAAE,qBAAqB;EACpC,sBAAsB;EACtB,yCAAyC;EACzC,SAAS;AACX;AACA,yBAAyB,eAAe,EAAE,yBAAyB,EAAE,qBAAqB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AACnI;EACE,iBAAiB;EACjB,mBAAmB;EACnB,wBAAwB,EAAE,eAAe;EACzC,eAAe;AACjB;AACA,+BAA+B,iBAAiB,EAAE;AAClD;EACE,uBAAuB;AACzB;AACA;EACE,eAAe,EAAE,gBAAgB,EAAE,iBAAiB;EACpD,kBAAkB;AACpB;AACA;EACE,wBAAwB,EAAE,eAAe,EAAE,mBAAmB;EAC9D,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,wBAAwB,EAAE,eAAe;EACzC,6BAA6B,EAAE,iBAAiB;EAChD,sBAAsB;EACtB,kBAAkB;AACpB;AACA,gCAAgC,kBAAkB,EAAE;AACpD,gCAAgC,sBAAsB,EAAE;AACxD;EACE,wBAAwB,EAAE,eAAe,EAAE,mBAAmB;EAC9D,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,iBAAiB,EAAE,yBAAyB,EAAE,qBAAqB;EACnE,mBAAmB,EAAE,gBAAgB;EACrC,kBAAkB;AACpB;AACA;EACE,aAAa,EAAE,+BAA+B;EAC9C,wBAAwB,EAAE,iBAAiB;EAC3C,6BAA6B;EAC7B,cAAc;EACd,yCAAyC;AAC3C;AACA,iCAAiC,gBAAgB,EAAE;AACnD,yBAAyB,mBAAmB,EAAE;AAC9C,yBAAyB,iBAAiB,EAAE,iBAAiB,EAAE;AAC/D;EACE,aAAa,EAAE,QAAQ;EACvB,gBAAgB;AAClB;AACA;EACE,SAAO;EACP,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,2BAA2B,EAAE,oBAAoB;AACnD;AACA,0EAA0E,0BAA0B,EAAE","sourcesContent":["/* Overall — pivot table styles */\n\n.overall-page {\n  display: grid;\n  grid-template-rows: 36px auto auto 1fr;\n  height: 100vh;\n  overflow: hidden;\n}\n.overall-body {\n  overflow: auto;\n  background: var(--bg);\n  padding-bottom: 80px;\n}\n\n/* KPI band */\n.kpi-band {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  border-bottom: 1px solid var(--rule);\n  background: var(--bg);\n}\n.kpi {\n  padding: 16px 18px 14px;\n  border-right: 1px solid var(--rule-soft);\n  display: flex; flex-direction: column; gap: 4px;\n}\n.kpi:last-child { border-right: 0; }\n.kpi .lbl {\n  font-size: 10px; text-transform: uppercase; letter-spacing: .08em; color: var(--ink-4);\n  font-weight: 600;\n}\n.kpi .val {\n  font-family: var(--mono); font-size: 22px;\n  font-feature-settings: 'tnum', 'zero';\n  color: var(--ink); letter-spacing: -.01em;\n  font-weight: 500;\n}\n.kpi .sub {\n  font-family: var(--mono); font-size: 10.5px; font-feature-settings: 'tnum';\n  color: var(--ink-3);\n}\n.kpi.diff .val { color: var(--diff); }\n.kpi.match .val { color: var(--match); }\n.kpi .spark {\n  margin-top: 4px;\n  height: 22px;\n  display: flex;\n  gap: 3px;\n  align-items: flex-end;\n}\n.kpi .spark .b {\n  width: 8px;\n  background: var(--ink-4);\n  opacity: .55;\n}\n.kpi .spark .b.cur { background: var(--accent); opacity: 1; }\n\n/* Filter strip */\n.overall-filters {\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid var(--rule);\n  background: var(--bg-elev);\n  font-size: 11.5px;\n  height: 32px;\n}\n.overall-filters .group {\n  display: flex; align-items: center; gap: 0;\n  padding: 0 8px;\n  border-right: 1px solid var(--rule-soft);\n  height: 100%;\n}\n.overall-filters .group .glbl {\n  font-size: 10px; text-transform: uppercase; letter-spacing: .06em;\n  color: var(--ink-4); margin-right: 6px;\n}\n.overall-filters .pill {\n  padding: 0 10px;\n  height: 22px;\n  display: inline-flex; align-items: center; gap: 5px;\n  font-size: 11px;\n  color: var(--ink-3);\n  border-radius: 3px;\n  cursor: pointer;\n  font-family: var(--mono);\n  font-feature-settings: 'tnum';\n}\n.overall-filters .pill:hover { background: var(--bg-sunk); color: var(--ink); }\n.overall-filters .pill[aria-pressed=\"true\"] {\n  background: var(--bg);\n  color: var(--ink);\n  box-shadow: inset 0 -2px 0 var(--ink);\n}\n.overall-filters .right {\n  margin-left: auto;\n  display: flex; gap: 14px; align-items: center;\n  padding: 0 14px;\n  font-family: var(--mono); font-size: 10.5px; color: var(--ink-3);\n  font-feature-settings: 'tnum';\n}\n.overall-filters .right b { color: var(--ink); font-weight: 500; }\n\n/* Pivot table */\n.pivot {\n  font-family: var(--mono);\n  font-feature-settings: 'tnum', 'zero';\n  font-size: 12.5px;\n}\n.pivot .ph,\n.pivot .pr {\n  display: grid;\n  grid-template-columns: 24px minmax(280px, 1.4fr) repeat(6, 1fr) 1.1fr;\n}\n.pivot .ph {\n  position: sticky; top: 0;\n  z-index: 5;\n  background: var(--bg-elev);\n  border-top: 1px solid var(--rule);\n  border-bottom: 1px solid var(--rule);\n  height: 56px;\n}\n.pivot .ph > div {\n  padding: 6px 10px;\n  border-right: 1px solid var(--rule-soft);\n  display: flex; flex-direction: column; justify-content: center;\n}\n.pivot .ph > div:last-child { border-right: 0; background: var(--bg); }\n.pivot .ph .co .short {\n  font-family: var(--mono); font-size: 13px; font-weight: 600;\n  color: var(--ink); letter-spacing: .04em;\n}\n.pivot .ph .co .full {\n  font-family: var(--sans); font-size: 10.5px; color: var(--ink-3);\n  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;\n}\n.pivot .ph .co .meta {\n  font-family: var(--mono); font-size: 9.5px; color: var(--ink-4);\n  font-feature-settings: 'tnum';\n  margin-top: 2px;\n}\n.pivot .ph .co .meta .dot {\n  display: inline-block; width: 6px; height: 6px; border-radius: 50%;\n  background: var(--match); margin-right: 4px;\n  vertical-align: middle;\n}\n.pivot .ph .co .meta.has-diff .dot { background: var(--diff); }\n\n.pivot .ph .first {\n  font-family: var(--sans);\n  font-size: 10.5px; text-transform: uppercase; letter-spacing: .08em;\n  color: var(--ink-3);\n}\n.pivot .ph .totalh {\n  font-family: var(--sans);\n  font-size: 11px; font-weight: 600;\n  color: var(--ink);\n  background: var(--bg);\n  text-transform: uppercase; letter-spacing: .04em;\n}\n.pivot .ph .totalh .meta {\n  font-family: var(--mono); font-size: 9.5px;\n  color: var(--ink-3); margin-top: 2px;\n  text-transform: none; letter-spacing: 0; font-weight: 400;\n}\n\n.pivot .pr {\n  border-bottom: 1px solid var(--rule-soft);\n  align-items: stretch;\n  height: 32px;\n  background: var(--bg);\n}\n.pivot .pr:hover { background: var(--bg-sunk); }\n.pivot .pr > div {\n  padding: 0 10px;\n  display: flex; align-items: center;\n  border-right: 1px solid var(--rule-soft);\n  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;\n  justify-content: flex-end;\n}\n.pivot .pr > div:last-child { border-right: 0; }\n.pivot .pr .lvl {\n  justify-content: center;\n  padding: 0;\n}\n.pivot .pr .name {\n  justify-content: flex-start;\n  font-family: var(--sans); font-size: 12.5px;\n  color: var(--ink-2);\n}\n.pivot .pr.l0 .name { color: var(--ink); font-weight: 500; }\n.pivot .pr.total {\n  background: var(--bg-elev);\n  font-weight: 600;\n  border-top: 1px solid var(--rule);\n}\n.pivot .pr.total .name { color: var(--ink); }\n.pivot .pr.total .cell { color: var(--ink); font-size: 13px; }\n\n/* cell */\n.cell {\n  font-family: var(--mono);\n  font-size: 12.5px;\n  color: var(--ink);\n  position: relative;\n  cursor: pointer;\n}\n.cell:hover { background: var(--bg-sunk); }\n.cell.s-match { /* default */ }\n.cell.s-diff {\n  background: var(--diff-bg);\n  color: var(--diff);\n  box-shadow: inset 0 -2px 0 var(--diff);\n}\n.cell.s-diff:hover { background: color-mix(in oklab, var(--diff-bg) 70%, var(--bg-sunk)); }\n.cell.s-over {\n  background: var(--override-bg);\n  color: var(--override);\n  box-shadow: inset 0 -2px 0 var(--override);\n}\n.cell.s-over:hover { background: color-mix(in oklab, var(--override-bg) 70%, var(--bg-sunk)); }\n.cell.selected {\n  outline: 1.5px solid var(--accent);\n  outline-offset: -1.5px;\n  z-index: 1;\n}\n.cell .delta {\n  position: absolute;\n  bottom: 1px;\n  right: 6px;\n  font-size: 9.5px;\n  color: var(--diff);\n  font-feature-settings: 'tnum';\n  opacity: .85;\n}\n.cell.s-over .delta { color: var(--override); }\n\n.pivot .pr .total-col {\n  background: var(--bg-elev);\n  font-weight: 500;\n  font-size: 13px;\n}\n.pivot .pr.total .total-col { font-weight: 600; }\n\n/* Row level indent ind */\n.lvl-ind {\n  display: inline-block;\n  width: 10px;\n  height: 1px;\n  background: var(--ink-4);\n  margin-right: 8px;\n  opacity: .4;\n}\n\n/* selected detail panel */\n.detail-overlay {\n  position: fixed; right: 16px; bottom: 36px;\n  width: 360px;\n  max-height: 60vh;\n  background: var(--bg);\n  border: 1px solid var(--rule);\n  border-left: 3px solid var(--accent);\n  border-radius: 4px;\n  box-shadow: 0 8px 32px rgba(0,0,0,.12);\n  z-index: 60;\n  overflow: auto;\n  font-family: var(--sans);\n  font-size: 12px;\n}\n.detail-overlay .dh {\n  display: flex; align-items: baseline;\n  padding: 12px 14px 8px;\n  border-bottom: 1px solid var(--rule-soft);\n  gap: 10px;\n}\n.detail-overlay .dh .t { font-size: 11px; text-transform: uppercase; letter-spacing: .08em; color: var(--ink-3); font-weight: 600; }\n.detail-overlay .dh .x {\n  margin-left: auto;\n  color: var(--ink-3);\n  font-family: var(--mono); font-size: 14px;\n  cursor: pointer;\n}\n.detail-overlay .dh .x:hover { color: var(--ink); }\n.detail-overlay .body {\n  padding: 12px 14px 16px;\n}\n.detail-overlay .row-title {\n  font-size: 13px; font-weight: 500; color: var(--ink);\n  margin-bottom: 4px;\n}\n.detail-overlay .co-line {\n  font-family: var(--mono); font-size: 11px; color: var(--ink-3);\n  font-feature-settings: 'tnum';\n  margin-bottom: 12px;\n}\n.detail-overlay .row-val {\n  font-family: var(--mono); font-size: 22px;\n  font-feature-settings: 'tnum'; color: var(--ink);\n  letter-spacing: -.01em;\n  margin-bottom: 2px;\n}\n.detail-overlay .row-val.diff { color: var(--diff); }\n.detail-overlay .row-val.over { color: var(--override); }\n.detail-overlay .row-sub {\n  font-family: var(--mono); font-size: 11px; color: var(--ink-3);\n  font-feature-settings: 'tnum';\n  margin-bottom: 12px;\n}\n.detail-overlay .h {\n  font-size: 10.5px; text-transform: uppercase; letter-spacing: .08em;\n  color: var(--ink-4); font-weight: 600;\n  margin: 12px 0 6px;\n}\n.detail-overlay .pl {\n  display: grid; grid-template-columns: 1fr auto;\n  font-family: var(--mono); font-size: 11.5px;\n  font-feature-settings: 'tnum';\n  padding: 4px 0;\n  border-bottom: 1px solid var(--rule-soft);\n}\n.detail-overlay .pl:last-child { border-bottom: 0; }\n.detail-overlay .pl .l { color: var(--ink-3); }\n.detail-overlay .pl .v { color: var(--ink); text-align: right; }\n.detail-overlay .actions {\n  display: flex; gap: 6px;\n  margin-top: 14px;\n}\n.detail-overlay .actions a, .detail-overlay .actions button {\n  flex: 1;\n  text-align: center;\n  padding: 7px 10px;\n  border: 1px solid var(--rule);\n  border-radius: 3px;\n  font-size: 11.5px;\n  color: var(--ink-2);\n  background: var(--bg);\n  text-decoration: none;\n  font-family: var(--sans);\n  cursor: pointer;\n}\n.detail-overlay .actions a.primary, .detail-overlay .actions button.primary {\n  border-color: var(--accent); color: var(--accent);\n}\n.detail-overlay .actions a:hover, .detail-overlay .actions button:hover { background: var(--bg-sunk); }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
